import { render, staticRenderFns } from "./AllCourses.vue?vue&type=template&id=10356ffe&scoped=true"
import script from "./AllCourses.vue?vue&type=script&lang=js"
export * from "./AllCourses.vue?vue&type=script&lang=js"
import style0 from "./AllCourses.vue?vue&type=style&index=0&id=10356ffe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10356ffe",
  null
  
)

export default component.exports